module.exports = __webpack_public_path__ + "assets/img/lx.4c8478a7.png";